import angular from 'angular';
import modalDetails from './views/modalDetails.html';
import modalSum from './views/modalSum.html';
import modalUnindentification from './views/modalUnindentification.html';

class identificationSummarizeCtrl {
  constructor($scope, $uibModal, httpRequest, globalFn) {
    $scope.noAuthCheckDetailList = []; //当前未勾选数据
    $scope.companyProperty =
      localStorage.user_info &&
      JSON.parse(localStorage.user_info).sale.companyProperty;
    // 获取当前机构号并格式化数据
    $scope.indetOrgIdArr = [];
    // select 组件数据
    // httpRequest.post_currentUserTaxpayers().then((res) => {
    //   let result = res.data.value;
    //   result.forEach((item) => {
    //     item.text = item.id;
    //   });
    //   $scope.indetOrgListArr = result;
    //   for (let i = 0; i < $scope.indetOrgListArr.length; i++) {
    //     $scope.indetOrgIdArr.push($scope.indetOrgListArr[i].id);
    //   }
    //   // select2参数配置
    //   $scope.orgOptions = {
    //     data: $scope.indetOrgListArr,
    //     placeholder: '请选择',
    //     allowClear: true,
    //     width: '300px',
    //   };
    //   if ($scope.periodsList) {
    //     queryNotAuthDataByOrgIdAndAuthDate();
    //     indentInit();
    //   }
    // });
    //tree组件 获取机构信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkStyle: 'checkbox',
      },
    };
    httpRequest.get_getUserOrgList().then((res) => {
      $scope.orgList = res.data.value;
      // 展开节点及全选
      angular.forEach($scope.orgList, function (item, index) {
        item.open = true;
        item.checked = true;
        $scope.indetOrgIdArr.push(item.saleCreditCode);
      });
      // 默认全部数据
      $scope.selectedOrgList = $scope.orgList;
      if ($scope.periodsList) {
        queryNotAuthDataByOrgIdAndAuthDate();
        indentInit();
      }
    });
    function fixNumber(v) {
      if (v === null || v === '' || v === undefined) return '';
      return v.toFixed(2);
    }
    // 分页
    $scope.totalItems = 0;

    // 分页参数
    $scope.pageRequestDTO = {
      pageNum: 1,
      pageSize: 10,
      param: {},
    };
    // 点击分页
    $scope.pageChanged = () => {
      indentInit();
    };
    // 所属期变更
    $scope.getPeriod = () => {
      $scope.identCurrentPeriod = $('select').val().substring(7);
    };

    // 搜索按钮
    $scope.indetiSearch = () => {
      if ($scope.indetOrgIdArr[0] == '') $scope.indetOrgIdArr.splice(0, 1);
      queryNotAuthDataByOrgIdAndAuthDate();
      indentInit();
    };

    // 获取所属期
    httpRequest.post_queryCurentUserAllTaxPeriod().then((res) => {
      if (res.data.success) {
        $scope.identCurrentPeriod = res.data.value.currentPeriod;
        $scope.currentPeriod = res.data.value.currentPeriod;
        $scope.periodsList = res.data.value.periodsList;
        // if ($scope.orgOptions) {
        queryNotAuthDataByOrgIdAndAuthDate();
        indentInit();
        // }
      }
    });
    // 获取未认证数据统计
    let queryNotAuthDataByOrgIdAndAuthDate = () => {
      const authDateReq = {
        creditCodeList: $scope.indetOrgIdArr,
        periodCode: $scope.currentPeriod,
      };
      httpRequest.post_noCheckData(authDateReq).then((res) => {
        if (res.data.success) {
          let noAuthCheckDetailList = res.data.value.noAuthCheckDetailList;
          noAuthCheckDetailList.forEach((item) => {
            item.invoiceAmount = fixNumber(item.invoiceAmount);
            item.invoiceTax = fixNumber(item.invoiceTax);
          });
          $scope.noAuthCheckDetailList = noAuthCheckDetailList;
        }
      });
    };
    // 认证表格渲染
    let indentInit = () => {
      $scope.pageRequestDTO.param.creditCodeList = $scope.indetOrgIdArr;
      $scope.pageRequestDTO.param.periodCode = $scope.identCurrentPeriod;
      httpRequest
        .post_pageAuthStatisticsReport($scope.pageRequestDTO)
        .then((res) => {
          if (res.data.success) {
            // 回写分页参数
            $scope.totalItems = res.data.value.total;
            $scope.pageRequestDTO.pageNum = ++res.data.value.prePage;
            $scope.pageRequestDTO.pageSize = res.data.value.pageSize;
            let resList = res.data.value.list;

            resList.forEach((item) => {
              item.deductionValidTax = fixNumber(item.deductionValidTax);
              item.noDeductionValidTax = fixNumber(item.noDeductionValidTax);
              item.taxReturn = fixNumber(item.taxReturn);
            });
            $scope.resList = resList;
          }
        })
        .finally(() => {
          $scope.showTips = true;
        });
    };
    //机构勾选变化
    $scope.orgIdChange = (data) => {
      $scope.indetOrgIdArr.length = 0;
      angular.forEach(data, (item, index) => {
        $scope.indetOrgIdArr.push(item.saleCreditCode);
      });
      // $scope.indetOrgIdArr = data.split(',');
    };
    // 未认证弹窗
    $scope.modalUnindentification = (index, obj) => {
      const modalObj = {
        creditCode: obj.creditCode,
        periodCode: $scope.currentPeriod,
      };
      $uibModal.open({
        template: modalUnindentification,
        controller: 'modalUnindentificationCtrl',
        backdrop: 'static',
        // windowClass: "modalUnindentification",
        openedClass: 'mod-modal-unindentification mod-modal mod-modal-hg',
        // size:'modal-lg',
        resolve: {
          items3() {
            return modalObj;
          },
        },
      });
    };
    httpRequest.get_dictByTypeArr(['audit_result2']).then((res) => {
      $scope.dictionary = { ...res.data.value };
    });
    // 认证明细弹窗
    $scope.modalDetails = (index, obj) => {
      const modalObj = {
        creditCodeList: [obj.creditCode],
        periodCode: obj.periodCode,
        dictionary: $scope.dictionary,
      };
      $uibModal.open({
        template: modalDetails,
        controller: 'modalDetailsCtrl',
        backdrop: 'static',
        openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
        // windowClass: "modalSelConDetail",
        // size:'sm',
        resolve: {
          items2() {
            return modalObj;
          },
        },
      });
    };
    // 合计弹窗
    $scope.modalSum = (index, obj) => {
      const modalObj = {
        creditCode: obj.creditCode,
        periodCode: obj.periodCode,
      };

      $uibModal.open({
        template: modalSum,
        controller: 'modalSumCtrl',
        backdrop: 'static',
        openedClass: 'mod-modal-modalsum mod-modal mod-modal-hg',
        // size:'lg',
        resolve: {
          items1() {
            return modalObj;
          },
        },
      });
    };
  }
}

identificationSummarizeCtrl.$inject = [
  '$scope',
  '$uibModal',
  'httpRequest',
  'globalFn',
];
export default identificationSummarizeCtrl;



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/identificationSummarize/identificationSummarizeCtrl.js